import type { UseFormRegisterReturn, UseFormWatch } from 'react-hook-form';
import InputDateSingleComponent, {
  type DatepickerProps,
} from '../../styled-components/components/InputDate/InputDateSingle';
import type { OnChangeSingleDate } from '../../styled-components/components/InputDatepicker';

type InputDateSingleProps = Omit<DatepickerProps, 'onChange' | 'onBlur' | 'name'> & {
  watch: UseFormWatch<any>;
  register: UseFormRegisterReturn;
};
const InputDateSingle = ({
  id,
  watch,
  register: _register,
  ...props
}: Omit<InputDateSingleProps, 'ref'>) => {
  const { onChange: _onChange, onBlur: _onBlur, ref: __ref, ...register } = _register;

  const value = watch(register.name);
  const onChange = (date: OnChangeSingleDate) => {
    _onChange({
      target: {
        name: register.name,
        value: date,
      },
      type: 'change',
    });
    _onBlur({
      target: {
        name: register.name,
        value: date,
      },
      type: 'blur',
    });
  };

  return (
    <InputDateSingleComponent
      id={id || `id-${register.name}`}
      {...props}
      selected={value}
      dateFormat="MMMM d, yyyy h:mm aa"
      {...{
        ...register,
        onChange,
      }}
    />
  );
};

export default InputDateSingle;
